import React, { useEffect, useState } from 'react';
import { AppRouter } from './routes.';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { io } from "socket.io-client";
import apc from "./App.css"
import CustomToast from "./components/ui-elements/CustomToast";
import WarningModal from './components/warning/WarningModal';
import { useSelector } from 'react-redux';

const IS_LOCAL_ENV = process.env?.NODE_ENV === "development" || false;
const TEST_ENV = "production";
const socket = io(process.env.REACT_APP_SERVER);

const execToast = ({ title, text, type }) => {
    toast(<CustomToast
        title={title}
        text={text}
        type={type}
    />, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        closeButton: false,
    });
}

function App() {

    //alerta de registro de laboratorio
    const [showAlertModal, setShowAlertModal] = useState(false);
    const [warningModalProps, setWarningModalProps] = useState(null);
    const user = useSelector(state => state.auth.user);

    let errorSound = new Audio('/sounds/error_sound.mp3');

    const handleShowAlert = (props) => {
        if (user && user.role === "SuperAdmin" || user.role === "EcosystemEditor") {
            setWarningModalProps({
                ...props,
                handleClose: () => {
                    setShowAlertModal(false);
                },
                userType: user.role
            })
            setShowAlertModal(true);
        }
    }

    useEffect(() => {
        socket.on("LabMeasurementAlert", handleShowAlert);
        return () => {
            socket.off("LabMeasurementAlert", handleShowAlert);
        }
    }, []);

    return (
        <>
            <ToastContainer />
            <AppRouter></AppRouter>
            {showAlertModal &&
                <WarningModal {...warningModalProps} audio={errorSound} />
            }
        </>
    );
}

export default App;
export { socket, IS_LOCAL_ENV, TEST_ENV, execToast };